import React from 'react'
import TextInput from "components/TextInput";
import {PurchasingGroupTemplateFieldType} from "../../../../../templates/constants/PurchasingGroupTemplateFieldType";
import getObjectValue from "libs/getObjectValue";
import INPUT_TYPE from "constants/INPUT_TYPE";
import GridBlock from "components/GridBlock";
import Typography from "components/Typography";
import {Box} from "@material-ui/core";
import clsx from "clsx";
import Tr from "translations/Translations";
import DatePicker from "components/DatePicker";
import moment from "moment";
import DateFormats from "constants/DateFormats";

function TemplateMemberFormField(
    {
        formikProps,
        id,
        enabled,
        lastArchiveField,
        classes
    }) {
    const field = getObjectValue(id, formikProps.values, null);
    const createId = (key) => `${id}.${key}`

    const getInputType = () => {
        switch (field.type) {
            case PurchasingGroupTemplateFieldType.NUMBER:
            case PurchasingGroupTemplateFieldType.AGGREGATE:
                return INPUT_TYPE.NUMBER_DECIMAL
            case PurchasingGroupTemplateFieldType.PERCENTAGE:
                return INPUT_TYPE.NUMBER_POSITIVE_AMOUNT
            default:
                return undefined;
        }
    }

    const getReadonlyField = () => {
        const difference = !lastArchiveField ? false : (field.type === PurchasingGroupTemplateFieldType.TEXT || field.type === PurchasingGroupTemplateFieldType.DATE ?
            field.textValue !== lastArchiveField.textValue : field.decimalValue !== lastArchiveField.decimalValue)

        return (<GridBlock className={clsx(classes.fieldGrid, {[classes.gridFieldComparing]: !!lastArchiveField, [classes.difference]: difference})}>
            {!!lastArchiveField && getViewField(lastArchiveField)}
            {getViewField(field)}
        </GridBlock>)
    }

    const getViewField = (field) => {
        return <Box className={classes.fieldBox}>
            <Typography className={classes.fieldName}>{field.name}</Typography>
            {
                field.type === PurchasingGroupTemplateFieldType.TEXT || field.type === PurchasingGroupTemplateFieldType.DATE ?
                    <Typography
                        className={clsx({[classes.emptyValue]: !field.textValue})}>{!field.textValue ? Tr("empty_value") :
                        field.type === PurchasingGroupTemplateFieldType.DATE ? moment(field.textValue).format(DateFormats.DATE_FORMAT) : ""+field.textValue}</Typography> :
                    <Typography className={clsx({[classes.emptyValue]: field.decimalValue === null})}>
                        {field.decimalValue != null ? (("" + field.decimalValue).replaceAll(".", ",") +
                                (field.type === PurchasingGroupTemplateFieldType.PERCENTAGE ? " %" : ""))
                            : Tr("empty_value")}
                    </Typography>
            }
        </Box>
    }

    return (
        enabled ?
            (field.type !== PurchasingGroupTemplateFieldType.AGGREGATE) &&
            <>
                {field.type === PurchasingGroupTemplateFieldType.DATE ?
                    <div>
                        <DatePicker
                            label={field.name}
                            formikProps={formikProps}
                            id={createId("textValue")}
                            disabled={!enabled}
                            required={field.required}
                        />
                    </div> :
                    <TextInput
                        label={field.name}
                        formikProps={formikProps}
                        id={createId(PurchasingGroupTemplateFieldType.TEXT === field.type ? "textValue" : "decimalValue")}
                        disabled={!enabled}
                        type={getInputType()}
                        required={field.required}
                        endAdornment={PurchasingGroupTemplateFieldType.PERCENTAGE === field.type ? "%" : undefined}
                        multiline={PurchasingGroupTemplateFieldType.TEXT === field.type}
                    />
                }
            </> :
            getReadonlyField()
    )
}

TemplateMemberFormField.propTypes = {}

export default TemplateMemberFormField;